import { normalizeLocale, type SupportedLocale } from './config';

const COPY: Record<SupportedLocale, string> = {
  en: 'The image request is too large. Use fewer or smaller reference images, or shorten the prompt, and try again.',
  ar: 'طلب الصورة كبير جدًا. استخدم صورًا مرجعية أقل أو أصغر، أو اختصر الوصف، ثم حاول مرة أخرى.',
  es: 'La solicitud de imagen es demasiado grande. Usa menos imágenes de referencia o imágenes más pequeñas, o acorta la descripción, e inténtalo de nuevo.',
  'pt-BR':
    'A solicitação de imagem é muito grande. Use menos imagens de referência ou imagens menores, ou encurte a descrição, e tente novamente.',
  fr: "La demande d'image est trop volumineuse. Utilisez moins d'images de référence ou des images plus petites, ou raccourcissez la description, puis réessayez.",
  it: 'La richiesta di immagine è troppo grande. Usa meno immagini di riferimento o immagini più piccole, oppure accorcia la descrizione e riprova.',
  ko: '이미지 요청이 너무 큽니다. 참조 이미지 수나 크기를 줄이거나 설명을 짧게 한 후 다시 시도해 주세요.',
  de: 'Die Bildanfrage ist zu groß. Verwende weniger oder kleinere Referenzbilder oder kürze die Beschreibung und versuche es erneut.',
  ja: '画像リクエストが大きすぎます。参照画像の数やサイズを減らすか、説明を短くして、もう一度お試しください。',
  hi: 'इमेज अनुरोध बहुत बड़ा है। संदर्भ इमेज की संख्या या आकार घटाएँ, या विवरण छोटा करें और फिर कोशिश करें।',
  ru: 'Запрос изображения слишком большой. Уменьшите количество или размер референсных изображений либо сократите описание и повторите попытку.',
  zh: '图像请求过大。请减少参考图像的数量或大小，或缩短描述，然后重试。',
  'zh-TW': '影像請求過大。請減少參考影像的數量或大小，或縮短描述，然後重試。',
  vi: 'Yêu cầu hình ảnh quá lớn. Hãy giảm số lượng hoặc kích thước ảnh tham chiếu, hoặc rút ngắn mô tả rồi thử lại.',
  id: 'Permintaan gambar terlalu besar. Kurangi jumlah atau ukuran gambar referensi, atau persingkat deskripsi, lalu coba lagi.',
};

export function imageRequestSizeCopy(
  locale: string | null | undefined
): string {
  return COPY[normalizeLocale(locale)];
}
